<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Add language"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right"></div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div class="create-page">
                <form
                    class="create-page__form"
                   
                    (ngSubmit)="submitLanguage()"
                    novalidate
                >
                    <div class="language-form">
                        <!-- Language Name -->
                        <div class="create-page__group">
                            <label for="languageName">
                                Name

                                <span class="create-page__required">
                                    *
                                </span>
                            </label>

                            <div
                                class="create-page__control"
                                [class.create-page__control--invalid]="
                                    isSubmitted &&
                                    nameControl.invalid
                                "
                            >
                                <span class="create-page__control-icon">
                                    <svg
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="9"
                                        ></circle>

                                        <path
                                            d="M3 12h18"
                                        ></path>

                                        <path
                                            d="M12 3a15 15 0 0 1 0 18"
                                        ></path>

                                        <path
                                            d="M12 3a15 15 0 0 0 0 18"
                                        ></path>
                                    </svg>
                                </span>

                                <input
                                    id="languageName"
                                    type="text"
                                    formControlName="name"
                                    placeholder="Enter language name"
                                    autocomplete="off"
                                />
                            </div>

                            <p class="create-page__hint">
                                Enter a clear and recognizable
                                language name.
                            </p>

                            <p
                                class="create-page__error"
                                *ngIf="
                                    isSubmitted &&
                                    nameControl.hasError(
                                        'required'
                                    )
                                "
                            >
                                Language name is required.
                            </p>

                            <p
                                class="create-page__error"
                                *ngIf="
                                    isSubmitted &&
                                    nameControl.hasError(
                                        'maxlength'
                                    )
                                "
                            >
                                Language name cannot exceed
                                100 characters.
                            </p>

                            <p
                                class="create-page__error"
                                *ngIf="
                                    isSubmitted &&
                                    nameControl.hasError(
                                        'pattern'
                                    )
                                "
                            >
                                Language name can contain only
                                letters, spaces and hyphens.
                            </p>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="create-page__actions language-form__actions">
                         <button
                            type="button"
                            class="create-page__button create-page__button--secondary"
                            [disabled]="isSaving"
                            (click)="cancel()"
                        >
                            <i
                                class="fa fa-times-circle"
                                aria-hidden="true"
                            ></i>

                            <span>Cancel</span>
                        </button>

                        <button
                            type="submit"
                            class="create-page__button create-page__button--primary"
                            [disabled]="isSaving"
                        >
                            <span
                                class="create-page__spinner"
                                *ngIf="isSaving"
                                aria-hidden="true"
                            ></span>

                            <svg
                                *ngIf="!isSaving"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    d="M4 4h13l3 3v13H4Z"
                                ></path>

                                <path
                                    d="M8 4v6h8V4"
                                ></path>
                            </svg>

                            <span>
                                {{
                                    isSaving
                                        ? 'Saving...'
                                        : 'Save'
                                }}
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</div>